'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconStack = exports.Icon = exports.default = undefined;

require('font-awesome/css/font-awesome.css');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _IconStack = require('./IconStack');

var _IconStack2 = _interopRequireDefault(_IconStack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Icon2.default;
exports.Icon = _Icon2.default;
exports.IconStack = _IconStack2.default; /**
                                          * @copyright 2015, Andrey Popp <8mayday@gmail.com>
                                          * 
                                          */



//////////////////
// WEBPACK FOOTER
// ./~/react-fa/lib/index.js
// module id = 48
// module chunks = 88746230898986 114276838955818 162898551421021 236645034235845